import AboutStyle from '@/styles/pages/career/customize-career-page/_index.module.scss';
import {EditBannerIcon, useRef, useState, useEffect} from '@/imports-files/pages/career/customize-career-page';
import parse from 'html-react-parser';

export function About({formik, index, page_section, customizeCareerAction, isPreview, resetCareerPage}){
  const aboutTitle = useRef(formik.values.page_sections_attributes[index].career_about_section_attributes.title || page_section.title || '');
  const aboutDescription = useRef(formik.values.page_sections_attributes[index].career_about_section_attributes.description || page_section.description || '');
  const [flagForRender, setFlagForRender] = useState(0)

  function setOverlay(formik){
    const backgroundColor = formik.values.career_font_style_attributes.style_hash.style_2.background_color
    const image_url = formik.values.page_sections_attributes[index].career_about_section_attributes.image_url || '/images/pages/career/about.jpg'
    const property = `linear-gradient(0deg, ${customizeCareerAction.hexToRGB(backgroundColor, 0.5)}, ${customizeCareerAction.hexToRGB(backgroundColor, 0.5)}), url(${image_url})`
    return {background: property}
  }

  useEffect(() => {
    aboutTitle.current = formik.values.page_sections_attributes[index].career_about_section_attributes.title || page_section.title || ''
    aboutDescription.current = formik.values.page_sections_attributes[index].career_about_section_attributes.description || page_section.description || ''
    setFlagForRender(Math.random() * 10000)
  }, [resetCareerPage])

  return(
    <div className = {`${AboutStyle.About}`} id={page_section.uniq_reference}>
      <div className = {`${AboutStyle.About__Container}`}>
        {page_section.career_about_section_attributes.layout == 'with_image' && <div className = {`${AboutStyle.About__FirstOption}`}>
          <div className = {`${AboutStyle.About__LeftContent}`} style={customizeCareerAction.setBackgroundOverlay(formik, page_section.type)}>
            <div className = {`${AboutStyle.About__Image}`}>
              <img src = {formik.values.page_sections_attributes[index].career_about_section_attributes.image_url || '/images/pages/career/about.jpg'}></img>
              {/* <img src = {'/images/pages/career/about.jpeg'}></img> */}
              {!isPreview && <div className={`${AboutStyle.About__Image__EditIcon}`}>
                <input id   =   ""
                  accept    =   ".png, .jpg, .jpeg"
                  type      =   "file"
                  // name      =   {`page_sections_attributes.${index}.career_about_section_attributes.image`}
                  title      =   {customizeCareerAction.imageInfoContent('about_image')}
                  onChange  =   { (event) => customizeCareerAction.handleAboutChange(event, formik, index)} />
                <EditBannerIcon/>
              </div>}
            </div>
          </div>
          <div className = {`${AboutStyle.About__RightContent}`} style={customizeCareerAction.setBackgroundColor(formik, page_section.type)}>
              <div className = {`${ isPreview ? AboutStyle.About__ContentPreview : AboutStyle.About__ContentEditable }`}>
                <div className = {`${AboutStyle.About__SubTitle}`}>
                  {isPreview ? <div
                    suppressContentEditableWarning={true}
                    style={customizeCareerAction.setFontColor(formik, page_section.type)}
                  >{parse(aboutTitle.current)}</div>
                  :
                  <div
                    contentEditable={true}
                    onInput={(e)=> {
                      customizeCareerAction.titleLengthWarning(e.currentTarget.textContent)
                      formik.setFieldValue(`page_sections_attributes.${index}.career_about_section_attributes.title`, e.currentTarget.innerHTML)
                    }}
                    onPaste={(event)=> {
                      customizeCareerAction.onPastePreventStyling(event)
                    }}
                    onBlur={(e)=>  {
                      customizeCareerAction.updateAboutSection(formik, index)
                    }}
                    suppressContentEditableWarning={true}
                    dangerouslySetInnerHTML={{ __html: aboutTitle.current }}
                    style={customizeCareerAction.setFontColor(formik, page_section.type)}
                    />
                  }
                </div>
              </div>
              <div className = {`${ isPreview ? AboutStyle.About__ContentPreview : AboutStyle.About__ContentEditable }`}>
              <div className = {`${AboutStyle.About__Para}`}>
                {isPreview ? <p
                  suppressContentEditableWarning={true}
                  dangerouslySetInnerHTML={{ __html: aboutDescription.current }}
                  style={customizeCareerAction.setFontColor(formik, page_section.type)}
                />
                :
                <p
                  contentEditable={true}
                  onInput={(e)=> {
                    customizeCareerAction.descriptionLengthWarning(e.currentTarget.innerHTML)
                    formik.setFieldValue(`page_sections_attributes.${index}.career_about_section_attributes.description`, e.currentTarget.innerHTML)
                  }}
                  onPaste={(event)=> {
                    customizeCareerAction.onPastePreventStyling(event)
                  }}
                  onBlur={(e)=>  {
                    customizeCareerAction.updateAboutSection(formik, index)
                  }}
                  suppressContentEditableWarning={true}
                  dangerouslySetInnerHTML={{ __html: aboutDescription.current }}
                  style={customizeCareerAction.setFontColor(formik, page_section.type)}
                  max={1000}
                  />
                }
              </div>
              </div>
          </div>
        </div>}
        {/*{page_section.career_about_section_attributes.layout == 'without_image' && <div className = {!isPreview ? `${AboutStyle.About__SecondOption}` : `${AboutStyle.About__SecondOption} ${AboutStyle.About__NoBorder}`}>
          <div className = {`${AboutStyle.About__Content}`}>
            <div className = {`${ isPreview ? AboutStyle.About__ContentPreview : AboutStyle.About__ContentEditable }`}>
              <div className = {`${AboutStyle.About__SubTitle} ${AboutStyle.About__SecondOption__SubTitle}`}>
                {isPreview ? <h3
                  suppressContentEditableWarning={true}
                  dangerouslySetInnerHTML={{ __html: aboutTitle.current }}
                  style={customizeCareerAction.setFontColor(formik, page_section.type)}
                />
                :
                <h3
                  contentEditable={true}
                  onInput={(e)=> {
                    customizeCareerAction.titleLengthWarning(e.currentTarget.textContent)
                    formik.setFieldValue(`page_sections_attributes.${index}.career_about_section_attributes.title`, e.currentTarget.textContent)
                  }}
                  onBlur={(e)=>  {
                    customizeCareerAction.updateAboutSection(formik, index)
                  }}
                  suppressContentEditableWarning={true}
                  dangerouslySetInnerHTML={{ __html: aboutTitle.current }}
                  style={customizeCareerAction.setFontColor(formik, page_section.type)}
                  />
                }
              </div>
            </div>
            <div className = {`${ isPreview ? AboutStyle.About__ContentPreview : AboutStyle.About__ContentEditable }`}>
              <div className = {`${AboutStyle.About__Para} ${AboutStyle.About__SecondOption__Para}`}>
                {isPreview ? <p
                  suppressContentEditableWarning={true}
                  dangerouslySetInnerHTML={{ __html: aboutDescription.current }}
                  style={customizeCareerAction.setFontColor(formik, page_section.type)}
                />
                :
                <p
                  contentEditable={true}
                  onInput={(e)=> {
                    customizeCareerAction.descriptionLengthWarning(e.currentTarget.textContent)
                    formik.setFieldValue(`page_sections_attributes.${index}.career_about_section_attributes.description`, e.currentTarget.innerHTML)
                  }}
                  onBlur={(e)=>  {
                    customizeCareerAction.updateAboutSection(formik, index)
                  }}
                  suppressContentEditableWarning={true}
                  dangerouslySetInnerHTML={{ __html: aboutDescription.current }}
                  style={customizeCareerAction.setFontColor(formik, page_section.type)}
                  />
                }
              </div>
            </div>
          </div>
        </div>}*/}
      </div>
    </div>
  )
}